import { Button, DatePicker, message, Alert, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "../../Auth";
import imgSave from "../../saveImg";
import dataDefault from './data';
import compute, { columns, getChart } from "./compute";
import request from "@/method/request";
import { numConvert } from "@/method";
import Chart from './components/Chart'
import IsLableAuth from "../../IsLableAuth";
import _ from 'lodash';

const { MonthPicker } = DatePicker;


@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            data7_1: [],
            data1_1: [],
            data7_1_2: []
        }
    }

    componentDidMount() {
        this.getData(this.state.date);
        getChart(moment(this.state.date).format('YYYY'))
    }

    computeNum = (data) => {
        const { date, data7_1, data1_1, data7_1_2 } = this.state;
        data = compute(data, { date, data1_1, data7_1, data7_1_2 });
        this.setState({ data, loading: false, });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true });
            let data = JSON.parse(JSON.stringify(dataDefault));
            const month = moment(date).format('M');
            const year = moment(date).format('YYYY');

            const x = await request(`/t7_7_info?year=${year}&month=${month}`);

            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data
            }
            const isOpenLastFill = moment(date).isBefore(moment("2022-02"));
            if (!isOpenLastFill) {
                for (let i = 0; i < data.length; i++) {
                    data[i].last = numConvert(_.get(x, `data.lastYear.${i}.actual`, 0)).toFixed(2);
                }
            }


            this.setState({ data1_1: x.data.data1_1 || [], data7_1: x.data.data7_1 || [], data7_1_2: x.data.data7_1_2 || [] }, () => {
                this.computeNum(data);
            });

        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    onSave = async () => {
        try {
            this.setState({ loadingSave: true });
            let date = this.state.date;
            if (!date) {
                message.error('请选择年份月份');
                let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                return
            }

            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let data = this.state.data.map((x, i) => ({ ...x, year, month, sort: i }));

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }

            const x = await request('/t7_7_save', headres);
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                getChart(year);
                return
            }
            message.error(x.msg);
        } catch (err) {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_4', 1.5, '7.7', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} 7.7 Data Visualization 人效数据可视化`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_4').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading } = this.state;
        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_4" >
                    <Row>7.7 Data Visualization 人效数据可视化</Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, "YYYY-MM")}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str);
                                getChart(moment(str).format('YYYY'))
                            }}
                        />

                    </Row>
                    <Table
                        columns={columns(this.onChange, print, date)}
                        dataSource={data}
                        size="middle"
                        id="table4_1_4"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 500 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Alert
                        message={
                            <div>
                                表格关联
                                <IsLableAuth auth="read_1" {...this.props} path="/table/1">1.1</IsLableAuth> -
                                <IsLableAuth auth="read_7_1" {...this.props} path="/table/7_1">7.1</IsLableAuth>
                            </div>
                        }
                        type="info"
                        showIcon
                        style={{ display: "inline-block", marginRight: 10 }}
                    />
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_7_7">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
                <Chart />
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-7/index.js